/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Relative/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'
import TysiaChoice from 'DesignSystem/TysiaChoice/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Relative({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Postal/NewAddress/Content/Content/Related/Content/Relative",
  onChange
  
}) {
let relativeContactMethodIdValueData = fromData.useDataValue({ viewPath,
context: 'relative',
path: 'contact_method_id',
})
let newAddressContactMethodIdChangeData = fromData.useDataChange({ viewPath,
context: 'new_address',
path: 'contact_method_id',
})
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let relativeContactMethodIdValueData1 = fromData.useDataValue({ viewPath,
context: 'relative',
path: 'contact_method_id',
})
let newAddressContactMethodIdValueData = fromData.useDataValue({ viewPath,
context: 'new_address',
path: 'contact_method_id',
})
let aggregateData = fromAggregate.equals(relativeContactMethodIdValueData1, newAddressContactMethodIdValueData)
let relativePersonValueData = fromData.useDataFormat({ viewPath,
context: 'relative',
path: 'person',
format: fromFormat.personName,
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let relativeTypeValueData = fromData.useDataFormat({ viewPath,
context: 'relative',
path: 'type',
format: fromFormat.capitalize,
})
let relativeAddressValueData = fromData.useDataFormat({ viewPath,
context: 'relative',
path: 'address',
format: fromFormat.format_address,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<TysiaChoice
  viewPath={`${viewPath}/TysiaChoice`}
 borderWidth={1}
 borderColor={dtColorsNeutral200}
 type="secondary"
 paddingTop={dtSpaceXs}
 paddingBottom={dtSpaceXs}
 paddingLeft={dtSpaceLs}
 paddingRight={dtSpaceLs}
 data="relative.contact_method_id"
 id={relativeContactMethodIdValueData}
 data="new_address.contact_method_id"
 onClick={newAddressContactMethodIdChangeData}
>
{childProps => (
<div
  data-testid="Relative.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Radial
  viewPath={`${viewPath}/Radial`}
 data="relative.contact_method_id"
 data="new_address.contact_method_id"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
/>
<div
  data-testid="Relative.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Relative.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 color={dtColorsNeutral900}
 data="relative.person"
 format="/Data/format.js personName"
 text={relativePersonValueData}
/>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 marginLeft={dtSpaceS}
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 data="relative.type"
 format="/Data/format.js capitalize"
 text={relativeTypeValueData}
/>
)}
</TysiaTag>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXxs}
 color={dtColorsNeutral500}
 data="relative.address"
 format="/Data/format.js format_address"
 text={relativeAddressValueData}
/>
</div>
</div>
)}
</TysiaChoice>
{children}
</React.Fragment>)
}